import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createRocketbetCanonicalItems = () => [
    {
        id: 'welcome-deposit-bonus',
        promotion: {
            id: 'welcome-deposit-bonus',
            title: Verbiage.welcome_bonus,
            startDate: new Date('2026-01-01T00:00:00Z'),
            description: Verbiage.up_to_3000_bonus_on_your_first_3_deposits,
            buttonText: Verbiage.claim,
            url: '/casino/',
            banner: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus-detail.png'),
            action: true,
            footerText: Verbiage.rocketbet_promotions_footer_text_3000_welcome_bonus
        },
        surfaces: {},
        order: { promotions: 0 }
    },
    {
        id: 'tanked-3-first-blood-2',
        promotion: {
            id: 'tanked-3-first-blood-2',
            title: Verbiage.tanked_3_first_blood_2,
            description: Verbiage.tanked_3_first_blood_2_description,
            buttonText: Verbiage.play_now,
            url: '/p/nolimit-city/tanked_3_first_blood_2/',
            conditionalUrl: {
                loggedInUrl: '/player/p/nolimit-city/tanked_3_first_blood_2/',
                loggedOutUrl: '/p/nolimit-city/tanked_3_first_blood_2/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/tanked_3_first_blood_2/tanked_3_first_blood_2_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/tanked_3_first_blood_2/tanked_3_first_blood_2_mobile.png'),
            startDate: new Date('2026-06-11T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/tanked_3_first_blood_2/tanked_3_first_blood_2_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/tanked_3_first_blood_2/tanked_3_first_blood_2_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 0 }
    },
    {
        id: 'great-game-rockies',
        promotion: {
            id: 'great-game-rockies',
            title: Verbiage.great_game_rockies,
            description: Verbiage.great_game_rockies_description,
            buttonText: Verbiage.play_now,
            url: '/p/hacksaw-gaming/great_game_rockies/',
            conditionalUrl: {
                loggedInUrl: '/player/p/hacksaw-gaming/great_game_rockies/',
                loggedOutUrl: '/p/hacksaw-gaming/great_game_rockies/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/great_game_rockies/great_game_rockies_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/great_game_rockies/great_game_rockies_mobile.png'),
            startDate: new Date('2026-06-11T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/great_game_rockies/great_game_rockies_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/great_game_rockies/great_game_rockies_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 1 }
    },
    {
        id: 'tournaments',
        promotion: {
            id: 'tournaments',
            title: Verbiage.weekly_races,
            description: Verbiage.weekly_races_description_2,
            buttonText: Verbiage.start_now,
            url: '/tournaments/#/tournaments/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/races/races.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_1500_every_week
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/races/races.png'),
            badgeText: Verbiage.exclusive,
            conditionalButton: {
                activeText: Verbiage.start_now,
                inactiveText: Verbiage.soon,
                condition: 'afterStart'
            }
        },
        order: { promotions: 2, topSection: 2 }
    },
    {
        id: 'jackpot',
        promotion: {
            id: 'jackpot',
            title: Verbiage.rocket_jackpot_million_title,
            description: Verbiage.rocket_jackpot_million_description,
            buttonText: Verbiage.play_now,
            url: '/promotion-page/jackpot/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/jackpot/jackpot.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/jackpot/jackpot-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_all_caps
        },
        order: { promotions: 3 }
    },
    {
        id: 'raffles',
        promotion: {
            id: 'raffles',
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            buttonText: Verbiage.enter_now,
            url: '/tournaments/#/raffles/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/raffles/raffles.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_500_cash_prize
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/raffles/raffles.png'),
            badgeText: Verbiage.promotion,
            conditionalButton: {
                activeText: Verbiage.enter_now,
                inactiveText: Verbiage.soon,
                condition: 'afterStart'
            }
        },
        order: { promotions: 4, topSection: 3 }
    },
    {
        id: 'weekly-prizes',
        promotion: {
            id: 'weekly-prizes',
            title: Verbiage.rocket_weekly_prizes_title,
            description: Verbiage.rocket_weekly_prizes_description,
            buttonText: Verbiage.join_now,
            url: '/promotion-page/weekly-prizes/',
            startDate: new Date('2026-03-04T18:01:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_daily_rewards
        },
        order: { promotions: 5 }
    },
    {
        id: 'rewards-program',
        promotion: {
            id: 'rewards-program',
            title: Verbiage.rewards_program,
            description: Verbiage.rewards_program_description,
            buttonText: Verbiage.more_info,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            customTitleWidth: '70%',
            banner: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_vip_galaxy
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            badgeText: Verbiage.exclusive
        },
        order: { promotions: 6, topSection: 4 }
    },
    {
        id: 'inner-circle-telegram',
        promotion: {
            id: 'inner-circle-telegram',
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            buttonText: Verbiage.enter_now,
            url: 'https://t.me/rocketbetcom',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_exclusive_bonuses
        },
        order: { promotions: 7 }
    },
    {
        id: 'rakeboost-promo',
        promotion: {
            id: 'rakeboost-promo',
            title: Verbiage.rocket_rakeboost_promo_title,
            description: Verbiage.rocket_rakeboost_promo_description,
            buttonText: Verbiage.rocket_boost_up,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            banner: cfgToThemeCdnPath('/promotions/rakeboost_promo/rakeboost_promo.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_boost_your_rewards
        },
        order: { promotions: 8 }
    }
];
